import React, { useState, useEffect } from "react";
import "./ASEContent.css";
import Modal from "react-modal";
import { ASEData } from "./ASEContentData.jsx";
import AOS from 'aos'
import 'aos/dist/aos.css';

function ASEContent() {
  useEffect(() => {
    AOS.init({ duration: 800 })
  }, [])
  const [showModal, setShowModal] = useState(false);
  const [activeModal, setActiveModal] = useState("");

  const handleOpenModal = (val) => {
    setActiveModal(val);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setShowModal("");
  };

  return (
    <>
      <div className="ase-container">
        <div className="ase-wrap">
          <span className="tabs-bg"></span>
          {ASEData.map((item) => {
            let video = item.aseVideo;
            return (
              <div className="ase-row">
                <div className="ase-box" onClick={() => handleOpenModal(video)} data-aos="zoom-in-up">
                  <img
                    src={item.aseImage}
                    alt={item.aseName + " profile pic"}
                    className="ase-card-imgs"
                  />
                  <h3>{item.aseName}</h3>
                  <p className="ase-project">{item.aseProject}</p>
                  <p className="ase-market">{item.aseMarket}</p>
                </div>
                <Modal
                  isOpen={showModal && activeModal === video}
                  onRequestClose={() => setShowModal(false)}
                  // contentLabel="login Modal"
                  style={{
                    overlay: {
                      backgroundColor: "rgba(0, 0, 0, 0.75)",
                    },
                  }}
                >
                  <iframe
                    id="kmsembed-1_z06m2jc5"
                    width="100%"
                    height="85%"
                    src={item.aseVideo}
                    class="kmsembed"
                    allowfullscreen
                    webkitallowfullscreen
                    mozAllowFullScreen
                    allow="autoplay *; fullscreen *; encrypted-media *"
                    referrerPolicy="no-referrer-when-downgrade"
                    frameborder="0"
                    title="Testimonial"
                  ></iframe>
                  <h3>{item.aseName}</h3>
                  <p className="modal-project">{item.aseProject}</p>
                  <p className="modal-market">{item.aseMarket}</p>
                  <button
                    className="close closing-btn"
                    onClick={handleCloseModal}
                  >
                    <span>x</span> CLOSE
                  </button>
                </Modal>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default ASEContent;
